import React from 'react';
import PropTypes from 'prop-types';

import Icon from '../../base/Icon';

import {
  List,
  ListItem,
} from './styles';

export const LinksListComponent = ({ items }) => (
  <List>
    {
      items.map(item => (
        <ListItem>
          <a href={item.href}>{item.label} <Icon variant="drawer-caret" /></a>
        </ListItem>
      ))
    }
  </ List>
);

LinksListComponent.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
  })).isRequired,
};

LinksListComponent.defaultProps = { };

export default LinksListComponent;
